<script setup lang="ts">
import SearchBar from '@/components/ui/SearchBar.vue';
import { usePlayerAvailableValuesStore } from '@/stores/playerAvailableValues';
import { useFilterConfigurationStore } from '@/stores/filterConfiguration';
import { useProductListFiltersStore } from '@/stores/productListFilters';

const availableValuesStore = usePlayerAvailableValuesStore();
const filterConfigurationStore = useFilterConfigurationStore();
const filtersStore = useProductListFiltersStore();
</script>

<template>
  <SearchBar
    :countries="availableValuesStore.countries"
    :selected-country-ids="filtersStore.selectedCountries"
    :date-range="filtersStore.dateRange"
    :room-occupancy="filtersStore.roomOccupancy"
    :disabled-fields="filterConfigurationStore.disabledParameterFields"
    :auto-detect-initial-values="filtersStore.hasUserInteracted"
    :loading="filtersStore.loading"
    @countries-change="filtersStore.setCountries"
    @room-occupancy-change="filtersStore.setRoomOccupancy"
  />
</template>
